import { splitStringByGraphemes } from '@zephyr3d/base';

function layoutText(atlas, font, text, fontSize, maxWidth = 0) {
    const scale = fontSize / font.metrics.unitsPerEm;
    const lineHeight = (font.metrics.ascent - font.metrics.descent + font.metrics.lineGap) * scale;
    const glyphs = [];
    const lines = [];
    let x = 0;
    let y = 0;
    let maxLineWidth = 0;
    let prevGlyphIndex = 0;
    let lineIndex = 0;
    let lineStartGlyph = 0;
    const chars = splitStringByGraphemes(text);
    for (const ch of chars){
        if (ch === '\n') {
            maxLineWidth = Math.max(maxLineWidth, x);
            lines.push({
                width: x,
                glyphStart: lineStartGlyph,
                glyphEnd: glyphs.length
            });
            x = 0;
            y += lineHeight;
            prevGlyphIndex = 0;
            lineIndex++;
            lineStartGlyph = glyphs.length;
            continue;
        }
        const codePoint = ch.codePointAt(0);
        if (typeof codePoint !== 'number') {
            continue;
        }
        const glyphIndex = font.getGlyphIndex(codePoint);
        if (glyphIndex === 0) {
            prevGlyphIndex = 0;
            continue;
        }
        const glyph = font.getGlyph(glyphIndex);
        if (!glyph) {
            prevGlyphIndex = 0;
            continue;
        }
        const atlasGlyph = atlas.ensureGlyph(glyphIndex);
        const pairAdjustment = prevGlyphIndex ? font.getPairAdjustment(prevGlyphIndex, glyphIndex) : null;
        const kerning = prevGlyphIndex ? font.getKerning(prevGlyphIndex, glyphIndex) * scale : 0;
        const xOffset = pairAdjustment ? pairAdjustment.secondXPlacement * scale : 0;
        const advance = glyph.advanceWidth * scale;
        if (maxWidth > 0 && x > 0 && x + kerning + advance > maxWidth) {
            maxLineWidth = Math.max(maxLineWidth, x);
            lines.push({
                width: x,
                glyphStart: lineStartGlyph,
                glyphEnd: glyphs.length
            });
            x = 0;
            y += lineHeight;
            prevGlyphIndex = 0;
            lineIndex++;
            lineStartGlyph = glyphs.length;
        } else {
            x += kerning;
        }
        if (atlasGlyph) {
            glyphs.push({
                char: ch,
                glyphIndex,
                atlasGlyph,
                lineIndex,
                x,
                y,
                xOffset,
                advance
            });
        }
        x += advance;
        prevGlyphIndex = glyphIndex;
    }
    maxLineWidth = Math.max(maxLineWidth, x);
    lines.push({
        width: x,
        glyphStart: lineStartGlyph,
        glyphEnd: glyphs.length
    });
    return {
        glyphs,
        width: maxLineWidth,
        boxWidth: maxWidth > 0 ? Math.max(maxLineWidth, maxWidth) : maxLineWidth,
        height: Math.max(lineHeight, y + lineHeight),
        lineHeight,
        lines
    };
}

export { layoutText };
//# sourceMappingURL=text_layout.js.map
